module.exports = __webpack_public_path__ + "static/media/homepage-padlock.f1422c98.svg";